export default __webpack_public_path__ + "static/media/angelita_logo2.e7bddf86.png";